export const devFrontendClientId = 'b944cb11-4d23-4fb3-8672-fd3339b4f1a5';
export const testFrontendClientId = '30a0843e-bc3c-44e2-8a25-ccb68bcf8184';
export const prodFrontendClientId = 'bede8af6-3fd3-4efa-8b9e-0b291163bea6';

export const devApiClientId = '3366fe53-6111-4321-94bd-8446de5f1d64';
export const testApiClientId = '55427028-d86b-4f65-a746-48a9cd90055f';
export const prodApiClientId = '0f667453-06ae-4bcb-8edf-8d24f620595d';

export const tenantID = 'b4a8e931-f8f4-4453-b7db-c5f6476641f0';

export const devHostname = 'localhost';
export const awsTestHostName = 'admin-api.tst.data.services.frasers.io';
export const awsProdHostName = 'admin-api.prd.data.services.frasers.io';
export const azureTestHostName = 'translation-domain-api.salmontree-33c919ae.germanywestcentral.azurecontainerapps.io';
export const azureProdHostName = 'translation-domain-api.salmonwater-04b8c552.germanywestcentral.azurecontainerapps.io';

export const getApiClientId = () => {
	switch (process.env.ENVIRONMENT) {
		case 'tst':
			return testApiClientId;
		case 'prd':
			return prodApiClientId;
		default:
			return devApiClientId;
	}
};
